import React from "react";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import DateRangePicker from "../../../components/common/DateRangePicker";
import { formatDate } from "../../../components/common/Converter";
import PrintPayslip from "../../EmployeeSelfService/Payslip/print-payslip/PrintPayslip";
import Progress from "../../../components/Progress";
import PayslipAdminPresenter from "./PayslipAdminPresenter";
import InputFactory from "../../../components/InputFactory";

class PayslipPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PayslipAdminPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.contractPDF = React.createRef();
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
      payrollData: [],
      accountsTitle: [],
      monthlyRate: 0,
    };
  }

  getCollectionName() {
    return "payslip";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit, payrollData, accountsTitle, monthlyRate } = this.state;

    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "employee" &&
        fields !== "coverFrom" &&
        fields !== "coverTo" &&
        fields !== "payrollType" &&
        fields !== "jobType" &&
        fields !== "payItem"
    );
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <div className="d-none">
                <div ref={this.contractPDF} id="contractPDF">
                  <PrintPayslip
                    object={payrollData}
                    accountsTitle={accountsTitle}
                    monthlyRate={monthlyRate}
                    showWatermark={false}
                  />
                </div>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                <div className="col-md-4">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="col-md-4">
                    <DateRangePicker
                      fields={["coverFrom", "coverTo", ""]}
                      onFilter={(filterObj) => {
                        const where = {};
                        if (filterObj.coverFrom?.$gte) {
                          where.coverFrom = {
                            $gte: formatDate(filterObj.coverFrom.$gte),
                          };
                        }
                        if (filterObj.coverTo?.$lte) {
                          where.coverTo = {
                            $lte: formatDate(filterObj.coverTo.$lte),
                          };
                        }
                        this.searchSubmit(where);
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                printPayslip={(data) => this.presenter.handlePrint(data)}
                // remove={(data) => this.presenter.handleDeleteData(data)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "Print Payslip",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(PayslipPage);
